'use client';

import dynamic from 'next/dynamic';
import { useTheme } from '@/components/ThemeContext';

const FlowCanvas = dynamic(() => import('@/components/agent-flow/FlowCanvas'), { ssr: false });

export default function AgentPage() {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    return (
        <div className={`w-screen h-screen flex flex-col pt-16 transition-colors ${isDark ? 'bg-slate-900 text-slate-200' : 'bg-gray-50 text-gray-800'}`}>
            <div className="flex-1 overflow-hidden">
                <FlowCanvas />
            </div>
        </div>
    );
}
